import { INCREASE_TYPE } from './enum';
const { useI18n } = require('@fegobull/webapi').use;

const langTextMap = {
    0: {
        name: '名称',
        trend: '走势',
        increase: '涨幅',
        wch: '自选',
        add_selected_succ: '添加成功',
        del_selected_succ: '已从自选删除',
        [INCREASE_TYPE.CLOSE]: '涨跌幅',
        [INCREASE_TYPE.CLOSE_5DAY]: '5日涨跌幅',
        [INCREASE_TYPE.CLOSE_10DAY]: '10日涨跌幅',
        [INCREASE_TYPE.CLOSE_20DAY]: '20日涨跌幅',
        [INCREASE_TYPE.CLOSE_60DAY]: '60日涨跌幅',
        [INCREASE_TYPE.CLOSE_120DAY]: '120日涨跌幅',
        [INCREASE_TYPE.CLOSE_250DAY]: '250日涨跌幅',
        [INCREASE_TYPE.CLOSE_MONTH]: '月初至今',
        [INCREASE_TYPE.CLOSE_YEAR]: '年初至今'
    },
    1: {
        name: '名稱',
        trend: '走勢',
        increase: '升幅',
        wch: '自選',
        add_selected_succ: '添加成功',
        del_selected_succ: '已從自選刪除',
        [INCREASE_TYPE.CLOSE]: '漲跌幅',
        [INCREASE_TYPE.CLOSE_5DAY]: '5日漲跌幅',
        [INCREASE_TYPE.CLOSE_10DAY]: '10日漲跌幅',
        [INCREASE_TYPE.CLOSE_20DAY]: '20日漲跌幅',
        [INCREASE_TYPE.CLOSE_60DAY]: '60日漲跌幅',
        [INCREASE_TYPE.CLOSE_120DAY]: '120日漲跌幅',
        [INCREASE_TYPE.CLOSE_250DAY]: '250日漲跌幅',
        [INCREASE_TYPE.CLOSE_MONTH]: '月初至今',
        [INCREASE_TYPE.CLOSE_YEAR]: '年初至今'
    },
    2: {
        name: 'Name',
        trend: 'Trend',
        increase: '%Chg',
        wch: 'Watchlists',
        add_selected_succ: 'Added Successfully',
        del_selected_succ: 'Deleted',
        [INCREASE_TYPE.CLOSE]: '%Chg',
        [INCREASE_TYPE.CLOSE_5DAY]: '5D %Chg',
        [INCREASE_TYPE.CLOSE_10DAY]: '10D %Chg',
        [INCREASE_TYPE.CLOSE_20DAY]: '20D %Chg',
        [INCREASE_TYPE.CLOSE_60DAY]: '60D %Chg',
        [INCREASE_TYPE.CLOSE_120DAY]: '120D %Chg',
        [INCREASE_TYPE.CLOSE_250DAY]: '250D %Chg',
        [INCREASE_TYPE.CLOSE_MONTH]: 'MTD %Chg',
        [INCREASE_TYPE.CLOSE_YEAR]: 'YTD %Chg'
    },
    5: {
        name: '銘柄',
        trend: 'チャート',
        increase: '变化',
        wch: 'お気に入り',
        add_selected_succ: '追加完了',
        del_selected_succ: 'お気に入りから削除されました',
        [INCREASE_TYPE.CLOSE]: '変化率',
        [INCREASE_TYPE.CLOSE_5DAY]: '5日変化率',
        [INCREASE_TYPE.CLOSE_10DAY]: '10日変化率',
        [INCREASE_TYPE.CLOSE_20DAY]: '20日変化率',
        [INCREASE_TYPE.CLOSE_60DAY]: '60日変化率',
        [INCREASE_TYPE.CLOSE_120DAY]: '120日変化率',
        [INCREASE_TYPE.CLOSE_250DAY]: '250日変化率',
        [INCREASE_TYPE.CLOSE_MONTH]: '月初来',
        [INCREASE_TYPE.CLOSE_YEAR]: '年初来'
    }
};

export { langTextMap, useI18n };
